import { __values } from "tslib";
var MoloItem = /** @class */ (function () {
    function MoloItem() {
        this.available = 0;
        this.blocked = 0;
        this.colorBlocked = 0;
        this.colorCode = '';
        this.colorName = '';
        this.deliveryWindow = '';
        this.description = '';
        this.description2 = '';
        this.dispnos = 0;
        this.ean = '';
        this.fabric = '';
        this.gots = null;
        this.ecovero = null;
        this.itemId = '';
        this.masterId = '';
        this.msrp = 0;
        this.ocsno = '';
        this.grsno = '';
        this.organic = null;
        this.recycled = null;
        this.oekoTex = null;
        this.priceType = '';
        this.refill = '';
        this.seasonSort = 0;
        this.seasonCode = '';
        this.shelfNo = '';
        this.sizeCode = '';
        this.sizeName = '';
        this.usSize = '';
        this.whp = 0;
        this.deliveryShipmentDate = new Date();
        this.customerPrice = 0;
        this.ocsblended = '';
        this.discontinued = false;
        this.deliveryWindowLabel = '';
    }
    MoloItem.prototype.build = function (data) {
        //          console.log(data, 'build :: moloItem')
        this.available = data.available || 0;
        this.blocked = data.blocked || 0;
        this.colorBlocked = data.colorblocked || 0;
        this.colorCode = data.colorcode;
        this.colorName = data.colorname;
        this.deliveryWindow = data.deliveryWindow;
        this.description = data.description;
        this.description2 = data.description2;
        this.dispnos = data.dispnos;
        this.ean = data.ean;
        this.fabric = data.fabric;
        this.gots = data.gots;
        this.ecovero = data.ecovero;
        this.itemId = data.itemid;
        this.masterId = data.masterno;
        this.msrp = data.msrp;
        this.ocsno = data.ocsno || data.oscno || '';
        this.grsno = data.grsno || '';
        this.organic = data.organic;
        this.recycled = data.recycled;
        this.oekoTex = data.oekoTex;
        this.priceType = data.pricetype;
        this.refill = data.refill;
        this.seasonSort = data.seasonSort;
        this.seasonCode = data.seasoncode;
        this.shelfNo = data.shelfNo;
        this.sizeCode = data.sizecode;
        this.sizeName = data.sizename;
        this.usSize = data.ussize || data.usSize || '';
        this.whp = data.whp;
        this.ocsblended = data.ocsblended;
        this.customerPrice = data.customerprice || 0;
        var shipmentDate = new Date(data.shipmentdate);
        var today = new Date();
        this.deliveryShipmentDate = new Date(shipmentDate);
        this.deliveryWindowLabel = shipmentDate > today ? data.deliveryWindow : 'available now';
        return this;
    };
    MoloItem.prototype.buildFromSalesBook = function (data) {
        //        console.log(data, 'build :: moloItem for salesbook')
        this.available = data.Available || 0;
        this.blocked = data.blocked || 0;
        this.colorBlocked = data.colorblocked || 0;
        this.colorCode = data.colorcode;
        this.colorName = data.colorname;
        this.deliveryWindow = data.DeliveryWindow;
        this.description = data.description;
        this.description2 = data.description2;
        this.dispnos = data.dispnos || 0;
        this.ean = data.ean;
        this.fabric = data.Fabric;
        this.gots = data.GOTS;
        this.ecovero = data.ecovero;
        this.itemId = data.ItemId;
        this.masterId = data.masterno;
        this.msrp = data.MSRP;
        this.ocsno = data.ocsno || data.oscno || '';
        this.grsno = data.grsno || data.GRSno || '';
        this.organic = data.organic;
        this.recycled = data.recycled;
        this.oekoTex = data.OekoTex;
        this.priceType = data.pricetype;
        this.refill = data.Refill;
        this.seasonSort = data.SeasonSort;
        this.seasonCode = data.seasoncode;
        this.shelfNo = data.shelfNo;
        this.sizeCode = data.sizecode;
        this.sizeName = data.sizename;
        this.usSize = data.ussize || data.usSize || '';
        this.whp = data.WHP;
        this.ocsblended = data.ocsblended;
        this.customerPrice = data.customerprice || 0;
        var shipmentDate = new Date(data.shipmentdate);
        var today = new Date();
        this.deliveryShipmentDate = new Date(shipmentDate);
        // console.log(data, 'data :: build from salesbook')
        this.deliveryWindowLabel = data.DeliveryWindow;
        return this;
    };
    MoloItem.prototype.buildFromB2B = function (data) {
        //console.log(data, 'build :: moloItem')
        this.available = data.available || 0;
        this.dispnos = data.dispnos || 0;
        this.blocked = data.blocked || 0;
        this.colorBlocked = data.colorblocked || 0;
        this.colorCode = data.colorcode;
        this.colorName = data.colorname;
        this.deliveryWindow = data.deliveryWindow;
        this.description = data.description;
        this.description2 = data.description2;
        this.ean = data.ean;
        this.fabric = data.fabric;
        this.gots = data.gots;
        this.ecovero = data.ecovero;
        this.itemId = data.itemid;
        this.masterId = data.masterno;
        this.msrp = data.msrp;
        this.ocsno = data.ocsno || data.oscno || '';
        this.grsno = data.grsno || '';
        this.organic = data.organic;
        this.recycled = data.recycled;
        this.oekoTex = data.oekoTex;
        this.priceType = data.pricetype;
        this.refill = data.refill;
        this.seasonSort = data.seasonSort;
        this.seasonCode = data.seasoncode;
        this.shelfNo = data.shelfNo;
        this.sizeCode = data.sizecode;
        this.sizeName = data.sizename;
        this.usSize = data.ussize || data.usSize || '';
        this.whp = data.whp;
        this.customerPrice = data.customerprice || 0;
        this.ocsblended = data.ocsblended;
        var shipmentDate = new Date(data.shipmentdate);
        var today = new Date();
        this.deliveryShipmentDate = new Date(shipmentDate);
        // console.log(data, 'data :: build from salesbook')
        this.deliveryWindowLabel = data.deliveryWindow;
        return this;
    };
    return MoloItem;
}());
export { MoloItem };
export function mapMoloItems(data) {
    var e_1, _a;
    var mapped = [];
    try {
        for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
            var item = data_1_1.value;
            var newStyle = new MoloItem().build(item);
            mapped.push(newStyle);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return mapped;
}
export function mapMoloItemsFromSalesbook(data) {
    var e_2, _a;
    var mapped = [];
    try {
        for (var data_2 = __values(data), data_2_1 = data_2.next(); !data_2_1.done; data_2_1 = data_2.next()) {
            var item = data_2_1.value;
            var newStyle = new MoloItem().buildFromSalesBook(item);
            mapped.push(newStyle);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (data_2_1 && !data_2_1.done && (_a = data_2.return)) _a.call(data_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return mapped;
}
//# sourceMappingURL=MoloItem.js.map